"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareArgsForDifferentWeeksQuery = exports.getWeekNumberFromDateRangeByDate = void 0;
const ContainerHolder_1 = __importDefault(require("../Container/ContainerHolder"));
const config_consts_1 = require("../Container/config.consts");
const getWeekNumberFromDateRangeByDate = (date, range) => {
    const dateTimeModifier = ContainerHolder_1.default.getInstance().get(config_consts_1.SYSTEM_DATE_TIME_MODIFIER);
    const diff = dateTimeModifier.daysDiff(date, range.startDate);
    return Math.abs(Math.ceil(diff / 7)) + 1;
};
exports.getWeekNumberFromDateRangeByDate = getWeekNumberFromDateRangeByDate;
const prepareArgsForDifferentWeeksQuery = (periods, dateRange) => {
    const dateTimeModifier = ContainerHolder_1.default.getInstance().get(config_consts_1.SYSTEM_DATE_TIME_MODIFIER);
    const datesBorders = [dateRange.from, dateRange.to];
    const args = [];
    periods.forEach((period) => {
        datesBorders.forEach((border) => {
            if (dateTimeModifier.dateInDateRange(period.startDate, period.endDate, border)) {
                args.push({
                    periodId: parseInt(period.periodId),
                    week: (0, exports.getWeekNumberFromDateRangeByDate)(border, period),
                });
            }
        });
    });
    return args;
};
exports.prepareArgsForDifferentWeeksQuery = prepareArgsForDifferentWeeksQuery;
//# sourceMappingURL=getSubscriptionWeekFromDate.js.map